<!-- #737: Detail einer Notification samt aller ihrer Zustellungen.
     nx-detail-screen/nxDetailMain gibt es auf 4.0.x nicht — Aufbau aus nx-pageTitle-box +
     nx-headline-box-Abschnitten, Breadcrumbs nach user-view.component.html:1-10. -->
<div>

  <nx-pageTitle-box
    [bcRootLvlLabel]="'core.notificationDiagnostics.breadcrumb.settings'"
    [bcRootLvlPath]="'/settings'"
    [bcRootLvl1Label]="'core.notificationDiagnostics.breadcrumb.list'"
    [bcRootLvl1Path]="'/settings/notifications'"
    [icon]="'icon-notification'"
    [iconToolTip]="'core.notificationDiagnostics.pageTitle.iconTooltip' | translate"
    [label]="'core.notificationDiagnostics.detail.pageTitle'">
    @if (detail()) {
      <!-- title ist ein server-gerenderter Schnappschuss in der Sprache des Empfaengers. Ueber den
           label-Slot statt ueber [label], weil nx-pageTitle-box sein [label] intern durch
           | translate schickt. -->
      <ng-template nxTemplate="label">
        <span>{{ detail().title }}</span>
      </ng-template>
    }
  </nx-pageTitle-box>

  <!-- Pruefreihenfolge verbindlich: error() VOR loading(). notFound ist KEIN Fehler. -->
  @if (error()) {
    <div class="bg-white px-5 py-4 text-[#c0123c] border-t">
      {{ 'core.notificationDiagnostics.detail.loadErrorMessage' | translate }}
    </div>
  } @else if (loading()) {
    <div class="bg-white px-5 py-4 flex flex-row justify-center border-t">
      <p-progressSpinner [style]="{ width: '2rem', height: '2rem' }" strokeWidth="4"></p-progressSpinner>
    </div>
  } @else if (notFound()) {
    <!-- Die Notification kann durch die Aufbewahrungsfrist geloescht sein, waehrend man noch auf
         einen aelteren Listenstand schaut. Legitimes Ergebnis, kein Fehlerzustand. -->
    <nx-empty-box
      class="border-t"
      [label]="'core.notificationDiagnostics.detail.notFoundMessage'">
    </nx-empty-box>
  } @else if (detail()) {

    <!-- 1. Kopfdaten -->
    <nx-headline-box
      class="mt-2"
      [label]="'core.notificationDiagnostics.detail.headerHeadline' | translate">
    </nx-headline-box>
    <div class="bg-white border-b border-gray px-5 py-3 flex flex-col gap-1 text-[14px]">
      <div class="flex flex-row gap-2">
        <span class="w-56 text-[#848488]">{{ 'core.notificationDiagnostics.detail.typeKey' | translate }}</span>
        <span class="break-all">{{ detail().typeKey }}</span>
      </div>
      <div class="flex flex-row gap-2">
        <span class="w-56 text-[#848488]">{{ 'core.notificationDiagnostics.detail.recipient' | translate }}</span>
        <span class="break-all">{{ recipientDisplay() }}</span>
      </div>
      <div class="flex flex-row gap-2">
        <span class="w-56 text-[#848488]">{{ 'core.notificationDiagnostics.detail.createdAt' | translate }}</span>
        <span>{{ detail().createdAt | date:'dd.MM.yyyy HH:mm' }}</span>
      </div>
      <div class="flex flex-row gap-2">
        <span class="w-56 text-[#848488]">{{ 'core.notificationDiagnostics.detail.expiresAt' | translate }}</span>
        <span>{{ detail().expiresAt | date:'dd.MM.yyyy HH:mm' }}</span>
      </div>
      <div class="flex flex-row gap-2">
        <span class="w-56 text-[#848488]">{{ 'core.notificationDiagnostics.detail.readAt' | translate }}</span>
        <span>
          {{ detail().readAt ? (detail().readAt | date:'dd.MM.yyyy HH:mm') : ('core.notificationDiagnostics.detail.unread' | translate) }}
        </span>
      </div>
      <!-- deletedAt beantwortet "ich habe nie etwas bekommen": ist es gesetzt, war die Nachricht
           zugestellt und der Nutzer hat sie selbst weggeraeumt. Leer wird ausdruecklich benannt,
           eine leere Zelle saehe aus wie "keine Angabe". -->
      <div class="flex flex-row gap-2">
        <span class="w-56 text-[#848488]">{{ 'core.notificationDiagnostics.detail.deletedAt' | translate }}</span>
        <span>
          {{ detail().deletedAt ? (detail().deletedAt | date:'dd.MM.yyyy HH:mm') : ('core.notificationDiagnostics.detail.notDeleted' | translate) }}
        </span>
      </div>
      @if (detail().groupKey) {
        <div class="flex flex-row gap-2">
          <span class="w-56 text-[#848488]">{{ 'core.notificationDiagnostics.detail.groupKey' | translate }}</span>
          <span class="break-all">{{ detail().groupKey }}</span>
        </div>
      }
      <!-- Deep-Link nur als Text: das Frontend hat keine Deep-Link-Aufloesung, und der
           SidebarDeepLinkService ist ein voellig anderes Konzept (Sidebar-Query-Params). -->
      @if (detail().deepLink) {
        <div class="flex flex-row gap-2">
          <span class="w-56 text-[#848488]">{{ 'core.notificationDiagnostics.detail.deepLink' | translate }}</span>
          <span class="break-all">{{ detail().deepLink.type }} · {{ detail().deepLink.id }}</span>
        </div>
      }
    </div>

    <!-- 2. Inhalt: gerenderter Schnappschuss, kommt fertig uebersetzt — keine translate-Pipe. -->
    <nx-headline-box
      class="mt-2"
      [label]="'core.notificationDiagnostics.detail.contentHeadline' | translate">
    </nx-headline-box>
    <div class="bg-white border-b border-gray px-5 py-3 flex flex-col gap-1 text-[14px]">
      <div class="font-medium">{{ detail().title }}</div>
      @if (detail().body) {
        <div class="whitespace-pre-line">{{ detail().body }}</div>
      }
    </div>

    <!-- 3. contextPayload: laut Engine-Entscheidung der EINZIGE Ausgang fuer diese Daten. -->
    <nx-headline-box
      class="mt-2"
      [label]="'core.notificationDiagnostics.detail.payloadHeadline' | translate">
    </nx-headline-box>
    <div class="bg-white border-b border-gray px-5 py-3">
      <pre class="text-[13px] leading-[1.2rem] overflow-x-auto">{{ detail().contextPayload | json }}</pre>
    </div>

    <!-- 4. Zustellungen: je Kanal eine Zeile, derselbe Row-Baustein wie in der Liste. Hier ohne
         Verlinkung — die Notification steht bereits offen. -->
    <nx-headline-box
      class="mt-2"
      [label]="'core.notificationDiagnostics.detail.deliveriesHeadline' | translate">
    </nx-headline-box>
    @if (detail().deliveries?.length) {
      @for (delivery of detail().deliveries; track delivery.id) {
        <div
          notification-delivery-row
          [entry]="delivery"
          [linkToDetail]="false"
          [showParentFields]="false">
        </div>
      }
    } @else {
      <nx-empty-box [label]="'core.notificationDiagnostics.detail.noDeliveriesMessage'"></nx-empty-box>
    }

    <!-- 5. Abo-Einsicht: „hat der überhaupt E-Mail aktiviert?". Schreibgeschuetzt — es gibt keine
         Mutation, die Praeferenzen fuer Fremde setzt, und das ist Absicht. -->
    <nx-headline-box
      class="mt-2"
      [label]="'core.notificationDiagnostics.detail.subscriptionsHeadline' | translate">
    </nx-headline-box>
    @if (catalogError()) {
      <div class="bg-white px-5 py-4 text-[#c0123c]">
        {{ 'core.notificationDiagnostics.detail.subscriptionsErrorMessage' | translate }}
      </div>
    } @else if (catalogLoading()) {
      <div class="bg-white px-5 py-4 flex flex-row justify-center">
        <p-progressSpinner [style]="{ width: '2rem', height: '2rem' }" strokeWidth="4"></p-progressSpinner>
      </div>
    } @else if (catalog().length === 0) {
      <nx-empty-box [label]="'core.notificationDiagnostics.detail.subscriptionsEmptyMessage'"></nx-empty-box>
    } @else {
      <!-- Kopfzeile und Zeilen teilen dieselbe Flex-Geometrie, sonst laufen Spalten auseinander. -->
      <div class="flex flex-row items-center px-5 py-1 text-[14px] text-[#848488] bg-white border-b border-gray">
        <div class="grow"></div>
        @for (channel of channels; track channel) {
          <div class="w-28 shrink-0 flex flex-row justify-center">{{ channelLabelKey(channel) | translate }}</div>
        }
      </div>
      @for (type of catalog(); track type.typeKey) {
        <div class="flex flex-row items-center px-5 py-2 text-[14px] bg-white border-b border-gray">
          <div class="grow flex flex-col">
            <!-- label kommt fertig uebersetzt vom Server, deshalb keine translate-Pipe. -->
            <span>{{ type.label }}</span>
            <span class="text-[#848488] break-all">{{ type.typeKey }}</span>
          </div>
          @for (channel of channels; track channel) {
            <div class="w-28 flex flex-row justify-center">
              @switch (channelState(type, channel)) {
                @case ('on') {
                  <span class="text-[#1a8754]">{{ 'core.notificationDiagnostics.detail.channelOn' | translate }}</span>
                }
                @case ('off') {
                  <span class="text-[#c0123c]">{{ 'core.notificationDiagnostics.detail.channelOff' | translate }}</span>
                }
                @default {
                  <!-- HIDDEN heisst „fuer diesen Typ nicht vorgesehen" — nicht dasselbe wie
                       abgeschaltet, darf also kein Kreuz sein. -->
                  <span class="text-[#848488]">{{ 'core.notificationDiagnostics.detail.channelHidden' | translate }}</span>
                }
              }
            </div>
          }
        </div>
      }
    }
  }
</div>
